import { useEffect, useState } from 'react'

const DESKTOP_NAV_QUERY = '(min-width: 1025px)'

const useDesktopNav = () => {
  const [isDesktopNav, setIsDesktopNav] = useState(
    () => window.matchMedia(DESKTOP_NAV_QUERY).matches,
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(DESKTOP_NAV_QUERY)

    const handleChange = (event: MediaQueryListEvent) => {
      setIsDesktopNav(event.matches)
    }

    setIsDesktopNav(mediaQuery.matches)
    mediaQuery.addEventListener('change', handleChange)

    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return isDesktopNav
}

export default useDesktopNav
